import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/de/terms-of-use")({
  head: () => ({
    meta: [
      { title: "Nutzungsbedingungen — Picamini.online" },
      {
        name: "description",
        content: "Nutzungsbedingungen für die Verwendung der kostenlosen Online-Tools auf Picamini.online.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/de/nutzungsbedingungen" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/terms-of-use" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/terminos-de-uso" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/nutzungsbedingungen" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/terms-of-use" },
    ],
  }),
  component: DeTermsPage,
});

function DeTermsPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="de" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-8">
        <div className="space-y-3">
          <h1 className="text-3xl font-extrabold sm:text-4xl text-foreground">Nutzungsbedingungen</h1>
          <p className="text-sm text-muted-foreground">Gültig ab: September 2026</p>
        </div>

        <div className="surface-card p-6 sm:p-8 rounded-2xl bg-card border space-y-6 text-sm text-muted-foreground leading-relaxed">
          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">1. Nutzung der Dienste</h2>
            <p>
              Picamini.online stellt kostenlose Online-Tools für den Unterricht, Entscheidungsfindung und PDF-Bearbeitung zur Verfügung. Durch die Nutzung der Website erklären Sie sich mit diesen Bedingungen einverstanden.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">2. Zulässige Nutzung</h2>
            <p>
              Die Nutzung unserer Dienste ist für persönliche, schulische und kommerzielle Zwecke gestattet. Eine missbräuchliche Nutzung oder automatisierte Überlastung unserer Infrastruktur ist untersagt.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">3. Haftungsausschluss</h2>
            <p>
              Alle Werkzeuge werden "wie besehen" bereitgestellt. Wir bemühen uns um eine hohe Verfügbarkeit und Korrektheit, übernehmen jedoch keine Garantie für die ständige Fehlerfreiheit.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">4. Änderungen der Bedingungen</h2>
            <p>
              Wir behalten uns das Recht vor, diese Nutzungsbedingungen jederzeit anzupassen.
            </p>
          </section>
        </div>
      </main>

      <SiteFooter lang="de" />
    </div>
  );
}
